export enum DataLayerLabels {
  FormStatusError = 'Form Error',
  LoggedIn = 'Zalogowany',
  LoggedOut = 'Niezalogowany',
}
